/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.propertyconfiguration.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')

var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.propertyconfiguration = {};
proto.witbooking.backoffice.propertyconfiguration.v1 = require('./propertyconfiguration_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse>}
 */
const methodDescriptor_PropertyConfigurationAPI_CreatePropertyConfiguration = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/CreatePropertyConfiguration',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest,
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse>}
 */
const methodInfo_PropertyConfigurationAPI_CreatePropertyConfiguration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIClient.prototype.createPropertyConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/CreatePropertyConfiguration',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_CreatePropertyConfiguration,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.propertyconfiguration.v1.CreatePropertyConfigurationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIPromiseClient.prototype.createPropertyConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/CreatePropertyConfiguration',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_CreatePropertyConfiguration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse>}
 */
const methodDescriptor_PropertyConfigurationAPI_UpdateEngineAppearance = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/UpdateEngineAppearance',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest,
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse>}
 */
const methodInfo_PropertyConfigurationAPI_UpdateEngineAppearance = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIClient.prototype.updateEngineAppearance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/UpdateEngineAppearance',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_UpdateEngineAppearance,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.propertyconfiguration.v1.UpdateEngineAppearanceResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIPromiseClient.prototype.updateEngineAppearance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/UpdateEngineAppearance',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_UpdateEngineAppearance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse>}
 */
const methodDescriptor_PropertyConfigurationAPI_GetPropertyConfiguration = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/GetPropertyConfiguration',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest,
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse>}
 */
const methodInfo_PropertyConfigurationAPI_GetPropertyConfiguration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIClient.prototype.getPropertyConfiguration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/GetPropertyConfiguration',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_GetPropertyConfiguration,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.propertyconfiguration.v1.GetPropertyConfigurationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIPromiseClient.prototype.getPropertyConfiguration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/GetPropertyConfiguration',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_GetPropertyConfiguration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse>}
 */
const methodDescriptor_PropertyConfigurationAPI_GetConfigurationByPropertyName = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/GetConfigurationByPropertyName',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameRequest,
  proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameRequest,
 *   !proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse>}
 */
const methodInfo_PropertyConfigurationAPI_GetConfigurationByPropertyName = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIClient.prototype.getConfigurationByPropertyName =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/GetConfigurationByPropertyName',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_GetConfigurationByPropertyName,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.propertyconfiguration.v1.GetConfigurationByPropertyNameResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPIPromiseClient.prototype.getConfigurationByPropertyName =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.propertyconfiguration.v1.PropertyConfigurationAPI/GetConfigurationByPropertyName',
      request,
      metadata || {},
      methodDescriptor_PropertyConfigurationAPI_GetConfigurationByPropertyName);
};


module.exports = proto.witbooking.backoffice.propertyconfiguration.v1;

